module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-ru-RU.82aff0be.jpg";